<template>
  <div :id="'table-' + _uid" class="tableview">
    <div class="table-view show-scroll">
      <b-row id="tableview-head-row" class="table-view_headrow">
        <b-col class="table-view_headrow_col" cols="1">Nr</b-col>
        <b-col cols="7" class="table-view_headrow_col">Name</b-col>
        <b-col cols="2" class="table-view_headrow_col">Size</b-col>
        <b-col cols="2" class="table-view_headrow_col">Recency</b-col>
      </b-row>
      <b-row
        v-for="(row, item) in tableData"
        :key="row.id"
        class="table-view_row"
      >
        <b-col class="table-view_row_col" cols="1">
          <div class="table-view_row_col__count">{{ item + 1 }}</div>
        </b-col>
        <b-col :id="row.id" cols="7" class="table-view_row_col">
          <div
            class="table-view_row_col__count"
            :class="{ active: isSelected(row.id) }"
          >
            <b-link @click="showOptions(row)">{{ row.name }}</b-link>
          </div>
        </b-col>
        <b-col
          cols="2"
          class="table-view_row_col d-flex flex-column justify-content-center"
        >
          <div class="table-view_row_col__docs">{{ row.size }}</div>
        </b-col>
        <b-col
          cols="2"
          class="table-view_row_col d-flex flex-column justify-content-center"
        >
          <div class="table-view_row_col__docs">{{ row.recency }}</div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import { CrainData } from "./shared/CrainD3Vis";

export default {
  name: "TableView",
  components: {},
  props: {
    showTitle: Boolean,
    showControls: Boolean,
    showQuery: Boolean,
    showSortZ: Boolean,
    showColor: Boolean,
    showRecency: Boolean,
    showSize: Boolean,
    analyse: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      query: null,
      queryValid: true,
      table: null,
      tableData: [],
      selectedRows: [],
      selectedRowIds: []
    };
  },
  computed: {
    ...mapGetters(["activeVisual"]),
    ...mapState({
      subsetFilter: state => state.filter.subsetFilter
    }),
    filterItems() {
      return this.subsetFilter;
    },
    queryStringified: {
      get() {
        return JSON.stringify(this.analyse.config.query);
      },
      set(val) {
        try {
          this.analyse.config.query = JSON.parse(val);
          this.queryValid = true;
        } catch (error) {
          this.queryValid = false;
        }
      }
    }
  },
  watch: {
    filterItems() {
      if ("#table-" + this._uid !== this.activeVisual) {
        console.log("Updating #table-" + this._uid);
        this.query.subset_filters =
          this.subsetFilter.length > 0 ? [this.subsetFilter] : [];
        this.selectedRowIds = [];
        this.selectedRows = [];
        this.executeQuery();
      }
    }
  },
  mounted() {
    if (!this._uid) {
      console.error("Please set ID property");
      return false;
    }

    this.query = { ...this.analyse.config.query };

    this.query.subset_filters =
      this.subsetFilter.length > 0 ? [this.subsetFilter] : [];

    this.executeQuery();
  },
  destroyed() {},
  methods: {
    ...mapActions(["saveSubsetFilter", "saveActiveVisual"]),
    executeQuery() {
      this.table = new CrainData(JSON.stringify(this.query));

      this.table.load().then(res => {
        res.xLayers.forEach(element => {
          this.tableData.push({
            id: element[0]._id,
            name: element[0].name
          });
        });
        let index = 0;
        res.processedData.forEach(element => {
          this.tableData[index].size = element.data.size;
          this.tableData[index].recency = element.data.recency;
          index++;
        });
      });
    },
    showOptions(item) {
      this.selectRow(item);
      EventBus.$emit("showOptions", this.selectedRows);
    },
    selectRow(row) {
      if (
        _.find(this.selectedRowIds, r => {
          return r._id === row.id;
        })
      ) {
        if (this.selectedRowIds.length > 1) {
          if (
            _.findIndex(this.selectedRowIds, r => {
              return r._id === row.id;
            }) === 0
          ) {
            this.selectedRowIds.splice(
              _.findIndex(this.selectedRowIds, r => {
                return r._id === row.id;
              }),
              2
            );
            this.selectedRows.splice(
              _.findIndex(this.selectedRows, r => {
                return r.id === row.id;
              }),
              1
            );
          } else {
            this.selectedRowIds.splice(
              _.findIndex(this.selectedRowIds, r => {
                return r._id === row.id;
              }) - 1,
              2
            );
            this.selectedRows.splice(
              _.findIndex(this.selectedRows, r => {
                return r.id === row.id;
              }),
              1
            );
          }
        } else {
          this.selectedRowIds.splice(
            _.findIndex(this.selectedRowIds, r => {
              return r._id === row.id;
            }),
            1
          );
          this.selectedRows.splice(
            _.findIndex(this.selectedRows, r => {
              return r.id === row.id;
            }),
            1
          );
        }
      } else {
        if (this.selectedRowIds.length > 0) {
          this.selectedRowIds.push("OR");
        }
        this.selectedRowIds.push({ _id: row.id });
        this.selectedRows.push(row);
      }
      this.saveSubsetFilter(this.selectedRowIds);
      this.saveActiveVisual("#table-" + this._uid);
    },
    isSelected(id) {
      if (
        _.find(this.selectedRowIds, r => {
          return r._id === id;
        })
      ) {
        return true;
      }
    }
  }
};
</script>
